export default __webpack_public_path__ + "static/media/weapons02.cddbb3b9.png";